@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  @include sm-sohne;
  color: var(--dark-80);
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  word-break: break-word;

  flex: 1;
  justify-content: flex-end;

  [data-nextgen-chat='on'] & {
    @include md-sohne;
    line-height: 160%;
    color: var(--dark-90);
    padding: 12px 20px 12px 12px;
  }
}

.upgradeButton {
  align-self: flex-start;
}
